import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { FolderPermissions } from './FolderPermissions';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetFolderPermissionsQueryVariables = Types.Exact<{
  folderId: Types.Scalars['ID']['input'];
}>;


export type GetFolderPermissionsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, asset?: { __typename?: 'AudioAsset', id: string } | { __typename?: 'DocumentAsset', id: string } | { __typename?: 'FileAsset', id: string } | { __typename?: 'FolderAsset', id: string, permissions?: { __typename?: 'FolderPermissions', canEditTranscription: boolean, canAccessWithoutWatermark: boolean, canConvertInteractiveAsset: boolean, canCopyChildren: boolean, canCopyComment: boolean, canCreateChildren: boolean, canCreateComment: boolean, canCreateCommentAttachment: boolean, canDeleteChildren: boolean, canDeleteComment: boolean, canDeleteCommentAttachment: boolean, canDownloadChildren: boolean, canDownloadComment: boolean, canDownloadCommentAttachment: boolean, canEditUserPermissions: boolean, canManageResourceControlPolicies: boolean, canMoveChildren: boolean, canPrintComment: boolean, canReactToComment: boolean, canRestoreChildren: boolean, canShareChildren: boolean, canUpdateChildren: boolean, canUpdateCommentStatus: boolean, canVersionChildren: boolean, canView: boolean, canViewChildren: boolean, canViewComment: boolean, canViewUserGroup: boolean, canViewUserPermissions: boolean } | null } | { __typename?: 'ImageAsset', id: string } | { __typename?: 'InteractiveAsset', id: string } | { __typename?: 'InteractiveLiveAsset', id: string } | { __typename?: 'ModelAsset', id: string } | { __typename?: 'UnsupportedAsset', id: string } | { __typename?: 'VersionStackAsset', id: string } | { __typename?: 'VideoAsset', id: string } | null } | null };


export const GetFolderPermissions = /*#__PURE__*/ gql`
    query GetFolderPermissions($folderId: ID!) {
  account(by: {assetId: $folderId}) {
    id
    asset(id: $folderId) {
      id
      ...FolderPermissions
    }
  }
}
    ${FolderPermissions}` as unknown as DocumentNode<GetFolderPermissionsQuery, GetFolderPermissionsQueryVariables>;

          

          export const useGetFolderPermissionsQuery = (options?:QueryHookOptions<GetFolderPermissionsQuery, GetFolderPermissionsQueryVariables>) => useQuery(GetFolderPermissions, options);

          

          export type GetFolderPermissionsQueryOptions = QueryHookOptions<GetFolderPermissionsQuery, GetFolderPermissionsQueryVariables>;

          

          export const useGetFolderPermissionsLazyQuery = (options?:LazyQueryHookOptions<GetFolderPermissionsQuery, GetFolderPermissionsQueryVariables>) => useLazyQuery(GetFolderPermissions, options);

          

          export type GetFolderPermissionsQueryResult = ReturnType<typeof useGetFolderPermissionsQuery>;

          
